import { jsx as e, jsxs as c } from "react/jsx-runtime";
import { isEmpty as n } from "lodash-es";
import { useState as I } from "react";
import { useCollapse as $ } from "react-collapsed";
import h from "../../Icons/Minus.js";
import x from "../../Icons/Plus.js";
import { ListWrapper as L, ItemWrapper as v, LabelWrapper as g, StyledText as C, StyledIconExpanded as E, StyledIconCollapsed as S, SubItemsWrapper as y } from "./styles.js";
const W = ({ item: s, index: i }) => {
  const { id: o, href: r, text: l, state: f, subItems: p, itemLevel: m } = s, [t, d] = I(() => f === "Expanded"), { getCollapseProps: u, getToggleProps: a } = $({ isExpanded: t });
  return /* @__PURE__ */ c(v, { children: [
    /* @__PURE__ */ c(g, { id: o, $itemLevel: m, $index: i, children: [
      /* @__PURE__ */ e(
        C,
        {
          $isItemOpen: t,
          id: `${r}-${i}`,
          $itemLevel: m,
          href: r || "",
          target: "_self",
          children: l
        }
      ),
      t ? !n(p) && /* @__PURE__ */ e(
        E,
        {
          $itemLevel: m,
          $isItemOpen: t,
          onClick: () => {
            d(!t);
          },
          children: /* @__PURE__ */ e(h, { ...a() })
        }
      ) : !n(p) && /* @__PURE__ */ e(
        S,
        {
          $itemLevel: s.itemLevel,
          $isItemOpen: t,
          onClick: () => d(!t),
          children: /* @__PURE__ */ e(x, { ...a() })
        }
      )
    ] }),
    !n(p) && t && /* @__PURE__ */ e(y, { ...u(), children: /* @__PURE__ */ e(b, { items: p }) })
  ] });
}, b = ({ items: s = [], id: i }) => /* @__PURE__ */ e(L, { children: s.map((o, r) => {
  const { id: l } = o;
  return /* @__PURE__ */ e(W, { index: r, item: o }, l);
}) }, i);
export {
  b as default
};
